module.exports = __webpack_public_path__ + "img/hakata.204f8ca7.jpg";